import { Loadable } from '..';

export const CommandTypesCacheTimeout = 3600;

interface DirectlyAvailableSimCommandTypes {
  available: number[];
  isAtlasAccount: boolean;
}

export type DirectlyAvailableSimCommandTypesState = Loadable<DirectlyAvailableSimCommandTypes>;

export const getDefaultDirectlyAvailableCommandTypesState = (): DirectlyAvailableSimCommandTypesState => {
  return {
    available: [],
    isAtlasAccount: false,
    isLoading: false
  };
};
